import { createContext, useContext } from 'react';

import { NavigationMap } from '@lumapps/navigation/types';

export type NavigationAdminVisibleByReferenceContextType = NavigationMap['visibleByGroupReferences'];
export type NavigationAdminVisibleByReferenceContextDispatchType = (
    visibleByGroupReferencesToAdd: NavigationMap['visibleByGroupReferences'],
) => void;

/** Create a context to store the visibleByReference object of the main navigation */
export const NavigationAdminVisibleByReferenceContext = createContext<NavigationAdminVisibleByReferenceContextType>({});

/** Create a context to store the dispatch action to update the visibleByReference object */
export const NavigationAdminVisibleByReferenceDispatchContext =
    createContext<NavigationAdminVisibleByReferenceContextDispatchType>(() => null);

/** Hook to get the VisibleByReference context */
export const useNavigationAdminVisibleByReference = () => {
    return useContext(NavigationAdminVisibleByReferenceContext);
};

/** Hook to get the dispatch to update the VisibleByReference context */
export const useNavigationAdminVisibleByReferenceDispatch = () => {
    return useContext(NavigationAdminVisibleByReferenceDispatchContext);
};
